import React, { useEffect, useState } from 'react';
import ActivityResumeStackComponent from '../../components/activity-resume-stack/activity-resume-stack.component';
import LastEventsTableComponent from '../../components/last-events-table/last-events-table.component';
import ModalDefaultComponent from '../../components/modal-default/modal-default.component';
import BreadcrumbComponent from '../../components/breadcrumb/breadcrumb.component';
import WorkOrderComponent from '../../components/work-order/work-order.component';
import LoaderComponent from '../../components/loader/loader.component';
import { useNavigate } from 'react-router-dom';
import WorkOrderReadonlyComponent from '../../components/work-order/work-order-readonly.component';

import useAuthStatus from '../../hooks/auth/AuthHook';
import ApiService from '../../services/api/api.service';

import ItemActividadUltimosEventos from '../../models/ItemActividadUltimosEventos';
import ItemOrdenDeTrabajo from '../../models/ItemOrdenDeTrabajo';

interface IDashboardPageProps {};

const DashboardPage = (props : IDashboardPageProps) => {
    const navigate = useNavigate();
    const auth = useAuthStatus();

    const [loadingActivityResume, setLoadingActivityResume] = useState<boolean>(true);
    const [loadingLastEvents, setLoadingLastEvents] = useState<boolean>(true);
    const [workOrder, setWorkOrder] = useState<ItemOrdenDeTrabajo>();
    const [loading, setLoading] = useState<boolean>(false);
    const [updateTime, setUpdateTime] = useState<number>();

    useEffect(() => {
        if (auth.user) {
            if (auth.user.ModoBienvenida) {
                navigate('/main/bienvenida');
            }
            else {
                if (!auth.user.UsuarioAdmin) {
                    navigate('/main/ordenes-trabajo');
                }
                else {
                    setLoading(true);
                    ApiService.Post<number>("ResumenActividad", "GetDashboardUpdateTime", auth.user).then((response: number) => {
                        setUpdateTime(response);
                    }, () => {
                        setUpdateTime(30);
                    });
                }
            }
        }
    }, [auth.user, navigate]);

    useEffect(() => {
        if (!loadingActivityResume && !loadingLastEvents) {
            setLoading(false);
        }
        else {
            setLoading(true);
        }

        return () => {
            setLoading(false);
        };
    }, [loadingActivityResume, loadingLastEvents]);

    const onLastEventSelected = (item: ItemActividadUltimosEventos) : void => {
        if (auth.user) {
            setLoading(true);
            ApiService.Post<ItemOrdenDeTrabajo>("OrdenesTrabajo", "Get", auth.user, {
                "IdOrden": item.Id,
            }).then((response: ItemOrdenDeTrabajo) => {
                setWorkOrder(response);
                setLoading(false);
            }, (error: string) => {
                alert(error);
                setLoading(false);
            });
        }
    };

    return (
        <div className='d-flex flex-column h-100 w-100'>
            <div className="row m-0">
                <div className='col-12'>
                    <BreadcrumbComponent items={["Inicio", "Dashboard"]} />
                </div>
            </div>
            {
                auth.user && updateTime ? (
                    <div className="row m-0 flex-fill overflow-hidden">
                        <div className="col-12 col-md-6 h-50 h-md-100 px-2 overflow-auto">
                            <ActivityResumeStackComponent 
                                updateTime={updateTime}
                                onLoading={() => setLoadingActivityResume(true)}
                                onLoaded={() => setLoadingActivityResume(false)} />
                        </div>
                        <div className="col-12 col-md-6 h-50 h-md-100 px-2 overflow-auto">
                            <LastEventsTableComponent 
                                updateTime={updateTime}
                                onLoading={() => setLoadingLastEvents(true)}
                                onLoaded={() => setLoadingLastEvents(false)}
                                onSelected={onLastEventSelected} />
                            {
                                workOrder ? (
                                    <ModalDefaultComponent
                                        title="Orden de trabajo"
                                        onDismiss={() => setWorkOrder(undefined)}>
                                        {
                                            auth.user.UsuarioAdmin ? (
                                                <WorkOrderComponent 
                                                    workOrder={workOrder}
                                                    setLoading={setLoading} />
                                            ) : (
                                                <WorkOrderReadonlyComponent
                                                    workOrder={workOrder}
                                                    setLoading={setLoading} />
                                            )
                                        }
                                    </ModalDefaultComponent>
                                ) : (
                                    null
                                )
                            }
                        </div>
                    </div>
                ) : (
                    null
                )
            }
            <LoaderComponent loading={loading} />
        </div>
    );
};

export default DashboardPage;
